import { useLanguage } from "./LanguageContext";
import SmoothScrollLink from "./SmoothScrollLink";
import "./Services.css";

const Services = () => {
  const { t } = useLanguage();
  const stickyHeaderHeight = 70;

  return (
    <section id="services" className="services-section py-5">
      <div className="container">
        <div className="row justify-content-center align-items-center gy-4">
          
          {/* TESTO: order-1 gli dice di posizionarsi sempre in ALTO su mobile */}
          <div className="col-xl-9 col-12 order-1">
            <div className="main-card text-center p-4 border rounded shadow-sm h-100">
              <h2 className="h5 fw-bold mb-3">{t("servicesTitle")}</h2>
              <p>{t("servicesText")}</p>
            </div>
          </div>

          {/* IMMAGINE: order-2 le dice di posizionarsi sempre in BASSO su mobile */}
          <div className="col-xl-3 col-12 order-2 d-flex justify-content-center">
            <SmoothScrollLink
              to="ContactFAQ" 
              offset={stickyHeaderHeight}
              className="image-card-link d-block w-100"
              style={{ textDecoration: "none" }}
            >
              <div className="image-card shadow-sm mx-auto" style={{ cursor: "pointer" }}>
                <img
                  src="https://res.cloudinary.com/dtem45qog/image/upload/v1748182232/Megattera-5_kycamh.jpg"
                  alt={t("servicesImgAlt")}
                  className="img-fluid rounded"
                />
              </div>
            </SmoothScrollLink>
          </div>
          
        </div>
      </div>
    </section>
  );
};

export default Services;